exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-item[data-v-2364832a] {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n}\n.list-item > p[data-v-2364832a] {\n  font-family: Red Hat Display, system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n}\n.list-item > p[data-v-2364832a]:first-of-type {\n  width: 25%;\n}\n.list-item > p[data-v-2364832a]:not(:first-of-type) {\n  text-align: center;\n  flex: 1 1 0%;\n}\n\n", ""]);

// exports
